import { defineComponent as V, openBlock as o, createElementBlock as a, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, A = { key: 2 }, M = { key: 3 }, f = { key: 4 }, k = { key: 5 }, h = {
  name: "ScalarIconDoor"
}, _ = /* @__PURE__ */ V({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: l } = u(r);
    return (d, t) => (o(), a("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      i(d.$slots, "default"),
      e(l) === "bold" ? (o(), a("g", Z, t[0] || (t[0] = [
        n("path", { d: "M232,212H212V40a20,20,0,0,0-20-20H64A20,20,0,0,0,44,40V212H24a12,12,0,0,0,0,24H232a12,12,0,0,0,0-24ZM68,44H188V212H68Zm104,88a16,16,0,1,1-16-16A16,16,0,0,1,172,132Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (o(), a("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M200,40V224H56V40a8,8,0,0,1,8-8H192A8,8,0,0,1,200,40Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,40H192V216H64Zm104,92a12,12,0,1,1-12-12A12,12,0,0,1,168,132Z" }, null, -1)
      ]))) : e(l) === "fill" ? (o(), a("g", A, t[2] || (t[2] = [
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-68-72a12,12,0,1,1,12-12A12,12,0,0,1,164,144Z" }, null, -1)
      ]))) : e(l) === "light" ? (o(), a("g", M, t[3] || (t[3] = [
        n("path", { d: "M232,218H206V40a14,14,0,0,0-14-14H64A14,14,0,0,0,50,40V218H24a6,6,0,0,0,0,12H232a6,6,0,0,0,0-12ZM62,40a2,2,0,0,1,2-2H192a2,2,0,0,1,2,2V218H62Zm104,92a10,10,0,1,1-10-10A10,10,0,0,1,166,132Z" }, null, -1)
      ]))) : e(l) === "regular" ? (o(), a("g", f, t[4] || (t[4] = [
        n("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,40H192V216H64Zm104,92a12,12,0,1,1-12-12A12,12,0,0,1,168,132Z" }, null, -1)
      ]))) : e(l) === "thin" ? (o(), a("g", k, t[5] || (t[5] = [
        n("path", { d: "M232,220H204V40a12,12,0,0,0-12-12H64A12,12,0,0,0,52,40V220H24a4,4,0,0,0,0,8H232a4,4,0,0,0,0-8ZM60,40a4,4,0,0,1,4-4H192a4,4,0,0,1,4,4V220H60Zm104,92a8,8,0,1,1-8-8A8,8,0,0,1,164,132Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
